module.exports = __webpack_public_path__ + "media/images/gocanvas_mailerlogo-0789d767.png";